import Default from "./Default";
import CenteredCta from "./CenteredCta";

/**
 * @typedef {import("@prismicio/client").Content.TextSlice} TextSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<TextSlice>} TextProps
 * @param {TextProps}
 */
const Text = ({ slice: { variation, primary } }) => {
	switch (variation) {
		case "default":
			return <Default primary={primary} />;
		case "centeredCta":
			return <CenteredCta primary={primary} />;
		default:
			return null;
	}
};

export default Text;
